import { createAsyncThunk } from "@reduxjs/toolkit";
import { backend, GetLensRunResponse, LensRunParams } from "Backend";

export const fetchLensRun = createAsyncThunk<GetLensRunResponse, LensRunParams>("case/lensRun", (lensRunParams) =>
  backend.getLensRun(lensRunParams)
);
